import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import NavigationMenu from './NavigationMenu/NavigationMenu';
import classNames from 'classnames';

interface NavbarProps {
	routes: types.routes.ISingleDashboardRoute[];
	pathname: string;
	handleRouteClick: (navigationType: string, routeName: string, parentName?: string) => void;
}

const TopNavigation = ({ routes, pathname, handleRouteClick }: NavbarProps) => {
	const [openMenu, setOpenMenu] = useState<number | null>(null);
	const menuRef = useRef<HTMLDivElement | null>(null);

	const handleClickOutside = (event: MouseEvent) => {
		if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
			setOpenMenu(null);
		}
	};
	const location = useLocation();

	useEffect(() => {
		toggleMenu(-1);
	}, [location]);

	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	const toggleMenu = (index: number) => {
		setOpenMenu(openMenu === index ? null : index);
	};

	return (
		<div className="navbar" ref={menuRef}>
			<ul className="nav-list">
				{routes.map((route, index) => (
					<Box
						component="li"
						key={index}
						className={classNames('nav-item nav-item-parent', {
							'active-parent': openMenu === index,
						})}
						display={{ lg: route.isHiddenDesktop ? 'none' : 'block' }}
					>
						<NavigationMenu
							route={route}
							toggleMenu={toggleMenu}
							index={index}
							pathname={pathname}
							openMenu={openMenu}
							handleRouteClick={handleRouteClick}
						/>
						{route.views && openMenu === index && (
							<ul className="sub-menu" id={`submenu-${index}`} role="menu">
								{route.views.map((view, viewIndex) => (
									<li key={viewIndex} className="sub-menu-item">
										<NavigationMenu
											route={view}
											toggleMenu={toggleMenu}
											index={viewIndex}
											pathname={pathname}
											openMenu={openMenu}
											parentName={route?.name}
											handleRouteClick={handleRouteClick}
										/>
									</li>
								))}
							</ul>
						)}
					</Box>
				))}
			</ul>
		</div>
	);
};

export default TopNavigation;
